import { InfoBadge, InfoBadgeTypes, Text } from '@procurify/ui'

import { useProcurifyIntl } from '@webapp/hooks'
import { type NavigationNotificationCount } from '../../../stores/notificationCount'
import messages from '../messages'
import { NavigationSublinkStyled } from '../styles/NavigationSublinkStyled'
import { type TagType, TagTypes } from '../types'

export interface INavigationSublinkProps {
  id: string
  title: string
  to: string
  legacy?: boolean
  notificationKey?: string
  notificationCount: NavigationNotificationCount
  active?: boolean
  tag?: TagType
  isPromo?: boolean
  onClick?: () => void
}

export const NavigationSublink = ({
  title,
  to,
  notificationKey,
  legacy = false,
  notificationCount = {},
  active,
  id,
  tag,
  isPromo,
  onClick,
}: INavigationSublinkProps) => {
  const intl = useProcurifyIntl()

  const tagText =
    tag === TagTypes.NEW
      ? intl.formatMessage(messages.newTag)
      : intl.formatMessage(messages.betaTag)

  let badgeCount = null
  if (notificationKey && notificationCount[notificationKey] > 0) {
    badgeCount = notificationCount[notificationKey]
  }

  return (
    <NavigationSublinkStyled
      id={id}
      to={to}
      legacy={legacy}
      isPromo={isPromo}
      className={active ? 'active' : ''}
      onClick={onClick}
    >
      <Text bold={active}> {title}</Text>
      {badgeCount > 0 && <Text bold> {badgeCount}</Text>}
      {tag && (
        <InfoBadge
          size='small'
          type={InfoBadgeTypes.HIGH_PRIORITY}
          text={tagText}
        />
      )}
    </NavigationSublinkStyled>
  )
}
